<template>
  <div>
    <vs-sidebar click-not-close parent="#aset-app" :hidden-background="true" class="full-vs-sidebar aset-view-sidebar items-no-padding" v-model="isJurnalActive" position-right>
      <div class="px-0 sm:pb-6 h-full aset-area-loading">
        <div class="flex flex-wrap items-center justify-between md:px-8 px-6 pt-4 d-theme-dark-bg aset-header bg-primary">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="closeAkumulasiView" class="cursor-pointer mr-4" svg-classes="text-white w-6 h-6"></feather-icon>
              <h5 class="text-white">{{ Object.entries(this.data).length === 0 ? "New" : "View" }} Akumulasi</h5>
            </div>
          </div>

          <div class="ml-10 mb-4 mt-1 flex items-center" v-if="status">
            <vs-switch class="ml-2" color="dark" v-model="disabled" v-can="'E'" v-if="Object.entries(this.data).length != 0"/>
            <vs-button class="ml-4" color="danger" size="small" icon-pack="feather" icon="icon-trash" @click="hapusJurnalConfirm()" v-can="'D'">Trash</vs-button>
          </div>
          <div class="ml-10 mb-4 mt-1 flex items-center" v-else>
            <vs-button class="ml-4" color="warning" size="small" icon-pack="feather" icon="icon-refresh-ccw" @click="restoreJurnalConfirm()" v-can="'D'">Restore</vs-button>
          </div>
        </div>

        <component :is="scrollbarTag" class="aset-content-scroll-area md:px-8 pt-4 px-6 mt-base" :settings="settings" :key="$vs.rtl">
          <div class="vx-col w-full sm:w-3/4 items-center sm:flex-row flex-col mx-auto">
            
            <!-- Data Aset -->
            <div class="vx-row mb-4">
              <div class="vx-col w-1/2">
                <h5 class="mb-4">{{dataAset.name}}</h5>
                <p>Kategori</p>
                <h5 class="mb-4">{{dataAset.kategori}}</h5>
                <p>Tanggal</p>
                <h5>{{dataAset.tanggal}}</h5>
              </div>
              <div class="vx-col w-1/2">
                <p class="flex justify-end">Harga</p>
                <h5 class="flex justify-end mb-4">{{dataAset.task_price | currency}}</h5>
                <h5 class="flex justify-end mb-4">{{dataAset.task_quantity}} {{dataAset.satuan}}</h5>
                <p class="flex justify-end">Total</p>
                <h5 class="flex justify-end">{{dataAset.task_total | currency}}</h5>
              </div>
            </div>
            <!-- // DATA ASET -->

            <vs-divider class="my-5"></vs-divider>

            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <span class="text-sm">Tanggal Akumulasi</span>
                <datepicker placeholder="Select Date" v-model="dataTanggal" :disabled="disabled"></datepicker>
              </div>
              <div class="vx-col w-1/2">
                <vs-input label="Jumlah Akumulasi" v-model="dataPrice" class="w-full jumlah" 
                name="item-jumlah" 
                v-validate="'required'" 
                :disabled="disabled"
                v-currency="{
                currency: null, 
                locale: 'de',
                precision:0,
                distractionFree:false
                }"/>
                <span class="text-danger text-sm" v-show="errors.has('item-jumlah')">{{ errors.first('item-jumlah') }}</span>
              </div>
            </div>
        
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-textarea label="Memo" v-model="dataMemo" class="w-full" name="item-memo" v-validate="'required'" :disabled="disabled"/>
                <span class="text-danger text-sm" v-show="errors.has('item-memo')">{{ errors.first('item-memo') }}</span>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col w-full">

                <template v-if="mobile === true">
                  <template v-if="Attachment" class="text-center">
                    <div class="img-container w-full">
                      <img :src="Attachment" class="responsive">
                      <vs-button class="" @click="cameraTakePicture" color="warning">Ulang Foto Attachment</vs-button>
                    </div>
                  </template>
                  <template v-else>
                    <vs-button class="w-full" @click="cameraTakePicture" color="warning">Ambil Foto Attachment</vs-button>
                  </template>
                </template>

                <template v-else>
                  <template v-if="Attachment">
                    <div class="img-container w-full" v-if="upImg">
                      <img :src="getImage('/tranksaksi/'+Attachment)" alt="" class="responsive" v-if="upImg">
                    </div>
                    <div class="img-container w-full">
                      <img :src="Attachment" alt="" class="responsive">
                    </div>
                    <div class="modify-img flex justify-between">
                      <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                      <vs-button class="w-full" @click="$refs.updateImgInput.click();upImg = false" color="warning" :disabled="disabled">Akumulasi Attachment (Image)</vs-button>
                    </div>
                  </template>

                  <div class="upload-img" v-else>
                    <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
                    <vs-button class="w-full" @click="$refs.uploadImgInput.click();upImg = false" color="warning" :disabled="disabled">Upload Attachment (Image)</vs-button>
                  </div>
                </template>
              </div>
            </div>

            <vs-divider class="mt-8"></vs-divider>
            <div class="vx-row" v-if="!disabled">
              <div class="vx-col w-1/2">
                <vs-button type="border" color="danger" @click="closeAkumulasiView">Cancel</vs-button>
              </div>
              <div class="vx-col w-1/2 flex justify-end">
                <vs-button class="mr-4 mb-2" :disabled="!isFormValid" @click="submitData" color="primary">Submit</vs-button>
              </div>
            </div>
          </div>
        </component>
      </div>

      <vs-prompt
        color="danger"
        title="Konfirmasi"
        @accept="hapusJurnalAccept"
        :active.sync="hapusJurnal">
        <div class="con-exemple-prompt">
          Yakin ingin menghapus Akumulasi ?
        </div>
      </vs-prompt>
      
      <vs-prompt
        color="warning"
        title="Konfirmasi"
        @accept="restoreJurnalAccept"
        :active.sync="restoreJurnal">
        <div class="con-exemple-prompt">
          Yakin ingin me-restore ?
        </div>
      </vs-prompt>

    </vs-sidebar>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar  from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import themeConfig from "@/../themeConfig.js"
import { CurrencyDirective } from 'vue-currency-input'
export default{
  props: {
    isJurnalActive: {
      type: Boolean,
      required: true
    },
    dataAset: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    status: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      // Set
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.50
        },
        disabled: false,
        hapusJurnal: false,
        restoreJurnal: false,


      // Mobile
        opti: {
          correctOrientation: true
        },
        dataLatitude: 0,
        dataLongitude: 0,

      // Init
        dataParent: 0,
        dataTasksID: 0,
        dataPrice: 0,
        dataQuantity : 1,
        dataTotal : 0,

        dataMemo: null,
        Attachment : null,
        upImg: true,
        
        dataTanggal: new Date()
    }
  },
  components: {
    Datepicker,
    VuePerfectScrollbar
  },
  directives: {
    currency: CurrencyDirective
  },
  watch: {
    isJurnalActive (value) {
      if (value) {
        if (Object.entries(this.data).length === 0) {
          this.disabled = false
          if (themeConfig.mobileMode === true) {
            navigator.geolocation.getCurrentPosition(this.loadLatLng  , this.mapError, { enableHighAccuracy: true });
          }
          this.initValues()
          this.$validator.reset()
        } else {
          this.disabled = true
          const { id, task_parent, task_unit, task_price, task_quantity, task_total, memo, tanggal, latitude, longitude, thumbnail, tasks_id } = JSON.parse(JSON.stringify(this.data))
          
          this.dataUnit = task_unit
          let euroGerman = Intl.NumberFormat("de-DE");
          this.dataPrice = euroGerman.format(task_price);
          this.dataQuantity = task_quantity
          this.dataTotal = task_total

          if (task_parent != 0) {
            this.dataParent = task_parent
          } else {
            this.dataParent = id
          }
          this.dataTasksID = tasks_id

          this.dataMemo = memo
          this.Attachment = thumbnail
          
          this.dataTanggal = tanggal

          this.dataLatitude = latitude
          this.dataLongitude = longitude
          
        }
      } else { return }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
    isFormValid () { 
      return !this.errors.any() && !this.disabled && this.dataPrice != 0 && this.dataMemo && this.Attachment && this.dataTanggal
    },
    mobile () {
      return themeConfig.mobileMode
    },
  },
  created () {
    if (themeConfig.mobileMode === true) {
      navigator.geolocation.getCurrentPosition(this.mapOnePosition, this.mapOneError, { enableHighAccuracy: true });
    }
  },
  methods: {
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          let formData = new FormData()
          this.dataPrice = this.dataPrice.split('.').join("")
          formData.set('task_title', 'Akumulasi - '+this.dataAset.name)
          formData.set('task_unit', '835')
          formData.set('task_price', this.dataPrice)
          formData.set('task_quantity', this.dataQuantity)
          formData.set('task_total', this.dataPrice * this.dataQuantity)
          formData.set('task_parent', this.dataParent)
          formData.set('tasks_id', this.dataTasksID)
          formData.set('task_sub_type', 'akumulasi')
          formData.set('task_group', this.dataAset.id)
          formData.set('comment_status', 'null')
          formData.set('task_password', 'null')

          formData.set('attachment_upload', this.upImg)
          if (this.upImg === false) { 
            formData.append('attachment_file', this.Attachment)
          } else {
            formData.set('attachment_file', this.Attachment)
          }

          let meta = {
            taxonomy: this.dataAset.taxonomy,
            memo: this.dataMemo,
            tanggal: this.formatDate(this.dataTanggal),
            latitude: this.dataLatitude,
            longitude: this.dataLongitude
          }
          formData.set('meta', JSON.stringify(meta))

          formData.set('taxonomy', this.dataAset.taxonomy)
          
          if (this.dataParent === 0) {
            formData.set('task_type', 'tranksaksi')
            formData.set('task_status', 'publish')
            this.$store.dispatch('aset/akumulasiAdd', formData)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.closeAkumulasiView()
              this.initValues()
            })
            .catch(error => {
              this.$vs.loading.close()
              //let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            formData.set('task_type', 'revision')
            formData.set('task_status', 'inherit')
            this.$store.dispatch('aset/akumulasiAdd', formData)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.closeAkumulasiView()
              this.initValues()
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
        }
      })
    },
    hapusJurnalConfirm () {
      this.hapusJurnal = true
    },
    hapusJurnalAccept () {
      if (Object.entries(this.data).length > 0) {
        this.$vs.loading()
        this.$store.dispatch('aset/akumulasiRemove', this.data)
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Berhasil',
            color  : 'success',
            text  : response.message,
          })
          this.initValues()
          this.closeAkumulasiView()
          this.initValues()
        })
      }
      this.hapusJurnal = false
    },
    restoreJurnalConfirm () {
      this.restoreJurnal = true
    },
    restoreJurnalAccept () {
      if (Object.entries(this.data).length > 0) {
        this.$vs.loading()
        this.$store.dispatch('aset/akumulasiRestore', this.data)
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Berhasil',
            color  : 'success',
            text  : response.message,
          })
          this.initValues()
          this.closeAkumulasiView()
          this.initValues()
        })
      }
      this.hapusJurnal = false
    },
    initValues() {
      this.dataLatitude = 0
      this.dataLongitude = 0

      this.dataParent = 0
      this.dataTasksID = 0
      this.dataPrice = 0
      this.dataQuantity = 1
      this.dataTotal = 0

      this.dataMemo = null
      this.Attachment = null
      this.upImg = true
      
      this.dataTanggal = new Date()
      this.disabled = false 
      this.hapusJurnal = false
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.Attachment = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    // MOBILE
    cameraTakePicture() { 
      if (themeConfig.mobileMode === true) {
        navigator.camera.getPicture(this.cameraSuccess, this.cameraFail,this.opti);
      }
    },
    cameraFail(message) { 
      this.$vs.notify({
        color : 'danger',
        text  : message,
      })
    }, 
    cameraSuccess (imageData) {
      this.Attachment = "data:image/jpeg;base64," + imageData;
    },
    mapOnePosition(position) {
      this.dataLatitude = position.coords.latitude
      this.dataLongitude = position.coords.longitude
    }, 
    mapOneError(error) {
      this.$vs.notify({
        color : 'danger',
        title : error.code,
        text  : error.message,
      })
    },
    loadLatLng(lokasi){
      if (lokasi) {
        if (this.dataLatitude != lokasi.coords.latitude 
          || this.dataLongitude != lokasi.coords.longitude) {
          this.dataLatitude = lokasi.coords.latitude
          this.dataLongitude = lokasi.coords.longitude
        }
      } else {
        this.$vs.notify({
          color : 'danger',
          title : 'Aktifkan GPS Lokasi anda',
        })
      }
    },
    mapError(error) {
      this.$vs.notify({
        color : 'danger',
        title : error.code,
        text  : error.message,
      })
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
    },
    closeAkumulasiView() {
      this.initValues()
      this.$emit('closeJurnal')
      this.initValues()
    }
  }
}
</script>
<style lang="scss" scoped>
.aset-view-sidebar {
  ::v-deep .vs-sidebar {
    .jumlah {
      text-align: center;
      .vs-con-input {
        .vs-input--input {
          text-align: center;
        }
      }
    }
  }
}
</style>